const config = {
	title: 'Humidity History',
	name: 'humidityHistory',
	defaultSort: 'Date desc',
	api: 'telemetry/summary',
	controllerType: 'elastic',
	readOnly: true,
	module: 'humidity',
	columns: [
		{
			field: 'sensorId',
			flex: 1,
			header: 'Sensor',
			lookup: 'sensor',
			required: true,
			hideable: false,
			sortable: false,
			filterable: false
		},
		{
			field: 'sensorCode',
			flex: 1,
			header: 'Sensor Code',
			lookup: 'sensor',
			required: true,
			hideable: false,
			sortable: false,
			filterable: false
		},
		{
			field: 'Date',
			flex: 1,
			header: 'Date/time stamp',
			type: 'date',
			time: false,
			showDateOnly: true,
			isUtc: false,
			isLocal: false,
		},
		{ field: 'avg', flex: 1, header: 'Reading (%)', type: 'number', elasticFilter: false },
		{ field: 'min', flex: 1, header: 'Min (%)', type: 'number', elasticFilter: false },
		{ field: 'max', flex: 1, header: 'Max (%)', type: 'number', elasticFilter: false }
	]
};

export default config;
